module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block absolute-children"
  }, [_c('div', {
    staticClass: "inline-block row",
    style: ({
      width: ((_vm.size / 10) * 2.5) + "rem"
    })
  }, [_c('div', {
    staticClass: "grid-6"
  }, [_c('button', {
    staticClass: "primary-green-bg left",
    style: ({
      width: (_vm.size / 10) + "rem"
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.positiveAction
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonText.accept.text || 'PROCEED') + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-6"
  }, [_c('button', {
    staticClass: "red-bg right",
    style: ({
      width: (_vm.size / 10) + "rem"
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.negativeAction
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonText.decline.text || 'DECLINE') + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15b8e501!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/button-panel/DualButtons.vue
// module id = 355
// module chunks = 2